import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Avatar from '@material-ui/core/Avatar';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { login, getMenu, getTenantInfo, AWSLogin, sendCodeWithSessionId } from '../services/Authentication';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ReactTitle } from 'react-meta-tags';
import GlobalStyle from '../../../styles/GlobalStyle';
import '../../../styles/index.css';
import BootstrapTooltip from '../../../shared/components/ToolTips';
import Footer from '../../../components/layout/footer/Footer';
import WarningDialog from '../../../shared/components/WarningDialog';
import AES from 'crypto-js/aes';
import queryString from "query-string";
import DoneIcon from '@material-ui/icons/DoneAll';

const LOGIN_style = {
  signTitle : {marginTop: '10px', fontSize: '1rem',marginBottom:'-20px'},
  awsloader:{position: "absolute",margin: "auto",width: "20%",height: "20%",top: '0',
         left: '0',bottom: '0',right: '0',fontSize: '20px',fontWeight: 'bold'
  },
  awsOption:{
    position:'relative','top':'10px','background':'#fff', 'fontWeight':'bold','padding':'5px'},
  awsLineOption:{'textAlign':'center','color':'#ccc','border-bottom': '1px solid #ccc','margin-bottom':'5px','margin-top':'5px'}  
}
class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      fields: { emailid: '', password: '' },
      errors: {},
      loading: false,
      success: false,
      pageLoading: false,
      pageTitle: 'Portal - Login',
      showWarning: false,
      awsLoader:false,
      reDirectedFromBot: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.submitLoginForm = this.submitLoginForm.bind(this);
    this.cancelAction= this.cancelAction.bind(this);
    this.confirmAction= this.confirmAction.bind(this);
  };
  async UNSAFE_componentWillMount() {
    const queryParams = queryString.parse(window.location.search)

    if(queryParams["state"]) {
      let sessionid = queryParams["state"].split("session=")[1]
      let params = {
        code: queryParams["code"],
        sessionid
      }
      this.setState({ 'reDirectedFromBot': true });
      this.props.showMessageBar('success', "Login successful");
      let result = await sendCodeWithSessionId(params);
      if( result && result.resp !== "Successful" ) {
        this.props.showMessageBar('error', "Something went wrong while sending code and session Id");
      }
      setTimeout(() => { window.close() }, 4000);    
      return;
    }
    
    if (this.props.user && this.props.user.isLoggedIn) {
      this.props.history.push(this.props.user.userRoles.landingPageUrl);
      return;
    }
    //Update status
   if (!this.props.hosttoken) {
      this.setState({ 'pageLoading': true });
      try {
        let response = await getTenantInfo();
        if (response.data) {
          sessionStorage.setItem('tenantConfig', JSON.stringify(response.data.tenantConfig));
          sessionStorage.setItem('hosttoken', response.data.hosttoken);
          this.props.addToState("tenantConfig", response.data.tenantConfig);
          this.props.addToState("hosttoken", response.data.hosttoken);
          this.setState({ 'pageLoading': false, pageTitle: `${response.data.tenantConfig.instituteName} - Login` });
          if(queryParams['code']){
            this.setState({awsLoader:true});
            sessionStorage.setItem('AWSCode', queryParams['code']);
            let params = {
              hosttoken:this.props.hosttoken,
              code:queryParams['code']
            }
            this.loginWithAWS(params);
          } else{
            this.setState({awsLoader:false});
          }
      
        }
        this.setState({ 'pageLoading': false})
      } catch (ex) {
        this.setState({ 'pageLoading': false});

        this.props.showMessageBar('error', ex.message);
      }
    } else {
      this.setState({ pageTitle: `${(this.props.tenantConfig && this.props.tenantConfig.instituteName)?this.props.tenantConfig.instituteName:''} - Login` });
      if(queryParams['code']){
        this.setState({awsLoader:true});
        sessionStorage.setItem('AWSCode', queryParams['code']);
        let params = {
          hosttoken:this.props.hosttoken,
          code:queryParams['code']
        }
        this.loginWithAWS(params);
      } else{
        this.setState({awsLoader:false});
      }
  
    }
  }
  async getToken() {
    try {
      let response = await getTenantInfo();
      if (response.data) {
        sessionStorage.setItem('tenantConfig', JSON.stringify(response.data.tenantConfig));
        sessionStorage.setItem('hosttoken', response.data.hosttoken);
        this.props.addToState("tenantConfig", response.data.tenantConfig);
        this.props.addToState("hosttoken", response.data.hosttoken);
      } else {
        throw Error('No tenant inforation found.');
      }
    } catch (ex) {
      throw ex;
    }
  }
  handleLoading = (isloading, isSuccess) => {
    this.setState({
      loading: isloading,
      success: isSuccess
    })
  }
  componentDidUpdate() {
    if (this.props.user && this.props.user.isLoggedIn) {
      this.props.history.push(this.props.user.userRoles.landingPageUrl);
      return;
    }
  }
  handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim();
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [name]: trimmedValue,
      },
    }));
  };
  cancelAction(){
    this.setState({
      showWarning:false 
    });
  }
  async confirmAction(){
    await this.submitLoginForm(null,true);
  }
  async submitLoginForm(e,override=false) {
    if(e){
      e.preventDefault();
    }
    try {
      this.handleLoading(true, false);
      await this.getToken();
      let password= AES.encrypt(this.state.fields.password, process.env.REACT_APP_SECRET_KEY).toString();
      let result = await login(this.state.fields.emailid, password,override);
      if(result.otpSid){
        this.handleLoading(false, true);
        this.props.disableMessage();
        this.props.addToState("mfaConfigs",result.mfaConfigs?result.mfaConfigs:{});
        this.props.addToState("otpSid", result.otpSid?result.otpSid:'');
        this.props.addToState("sessionId", result.sessionId?result.sessionId:'');
        this.props.addToState("username", this.state.fields.emailid);
        this.props.addToState("isMFANotConfigured", false);
        this.props.showMessageBar('success', result.message);
        this.props.history.push(`/verifyotp`);
      } else{
        if(result.data && result.data.dontShowMfaSetupModel){
          this.props.addToState("isMFANotConfigured", false);
        } else{
          this.props.addToState("isMFANotConfigured", true);
        }
        result.data.isLoggedIn = true;
        result.data.username = result.data.username ? result.data.username : this.state.fields.emailid;
        result.data.accessToken = result.accessToken;
        result.data.refreshToken = result.refreshToken;
        result.data.sessionId = result.sessionId;
        let restrictedPermissions= result.data.userRoles && result.data.userRoles.restrictedPermissions?result.data.userRoles.restrictedPermissions:[];
        sessionStorage.setItem('initialComponentIndentity', JSON.stringify(result.data.componentIndentity));
        sessionStorage.setItem('initialRestrictedPermissions', JSON.stringify(restrictedPermissions));
        sessionStorage.setItem('user', JSON.stringify(result.data));
        let menu = await getMenu();
        sessionStorage.setItem('menus', JSON.stringify(menu.data));
        this.handleLoading(false, true)
        this.props.disableMessage();
        if(result.data.tenantAccessList && result.data.tenantAccessList.length>0){
          let loggedIn= {tenant:result.data.tenantAccessList[0],menus:[]}
          sessionStorage.setItem('loggedIn', JSON.stringify(loggedIn));
          this.props.addToState("loggedIn", loggedIn);
        }
        this.props.addToState("user", result.data);
        this.props.addToState("menus", menu.data);
      }
    } catch (ex) {
      if(ex.name==='duplicateLogin'){
        this.setState({
          showWarning:true,
          loading: false, 
          success: false
        });
      }else{
        this.props.showMessageBar('error', ex.message);
        this.handleLoading(false, false);
      }
    }
  }

   onSingleSingin=()=>{
     window.location.href = this.props.tenantConfig.redirectUrl;
  }

  async loginWithAWS(params){
    let result = await AWSLogin(params);
    try {
      if(result.status===201){
        console.log(result)
          this.props.showMessageBar('error', result.message);
          setTimeout(() => {
            window.location.href= this.props.tenantConfig.logoutUrl;
          }, 2000);
      } else { 
        this.handleLoading(true, false);
        if(result.otpSid){
          this.handleLoading(false, true);
          this.props.disableMessage();
          this.props.addToState("mfaConfigs",result.mfaConfigs?result.mfaConfigs:{});
          this.props.addToState("otpSid", result.otpSid?result.otpSid:'');
          this.props.addToState("sessionId", result.sessionId?result.sessionId:'');
          this.props.addToState("username", this.state.fields.emailid);
          this.props.addToState("isMFANotConfigured", false);
          this.props.showMessageBar('success', result.message);
          this.props.history.push(`/verifyotp`);
        } else{
          if(result.data && result.data.dontShowMfaSetupModel){
            this.props.addToState("isMFANotConfigured", false);
          } else{
            this.props.addToState("isMFANotConfigured", true);
          }
          result.data.isLoggedIn = true;
          result.data.username = result.data.username ? result.data.username : this.state.fields.emailid;
          result.data.accessToken = result.accessToken;
          result.data.refreshToken = result.refreshToken;
          result.data.sessionId = result.sessionId;
          let restrictedPermissions= result.data.userRoles && result.data.userRoles.restrictedPermissions?result.data.userRoles.restrictedPermissions:[];
          sessionStorage.setItem('initialComponentIndentity', JSON.stringify(result.data.componentIndentity));
          sessionStorage.setItem('initialRestrictedPermissions', JSON.stringify(restrictedPermissions));
          sessionStorage.setItem('user', JSON.stringify(result.data));
          let menu = await getMenu();
          sessionStorage.setItem('menus', JSON.stringify(menu.data));
          this.handleLoading(false, true)
          this.props.disableMessage();
          if(result.data.tenantAccessList && result.data.tenantAccessList.length>0){
            let loggedIn= {tenant:result.data.tenantAccessList[0],menus:[]}
            sessionStorage.setItem('loggedIn', JSON.stringify(loggedIn));
            this.props.addToState("loggedIn", loggedIn);
          }
          this.props.addToState("user", result.data);
          this.props.addToState("menus", menu.data);
        }

      }
    } catch (ex) {
      if(ex.name==='duplicateLogin'){
        this.setState({
          showWarning:true,
          loading: false, 
          success: false
        });
      }else{
        this.props.showMessageBar('error', ex.message);
        this.handleLoading(false, false);
      }
    }
  }
  

  render() {
    const { classes } = this.props;
    if(this.state.reDirectedFromBot) {
      return (
        <div className='success-page-sso' >
          <h1><DoneIcon size={40}/> Login successful.</h1>
          <p>Please log out anytime by typing 'Logoff', 'Logout', 'Sign out', or 'Bye', or simply click the 'X' button at the top of the chat window. Thank you!</p>
        </div>
      )
    }
    if ( this.state.pageLoading ) {
      return (
        <CircularProgress size={40} className={classes.buttonProgress} />
      )
    }
    else if( !this.state.pageLoading && !this.props.tenantConfig ) {
      return <div style={{textAlign:'center'}}><h3>No such tenant exists.</h3></div>
      
    }
    return (
     
      !this.state.awsLoader?<user-login-container>
        <Container className={classes.wrapper} maxWidth={false} style={{ height: '100vh', backgroundImage: `url(${this.props.tenantConfig.backgroudImageUrl})` }} >
          <ReactTitle title={this.state.pageTitle} />
          <WarningDialog
            open={this.state.showWarning}
            titleText=""
            contentText="A user is already logged in with the same credentials. Your Log in will log user out from that session."
            cancelButtonText="Cancel"
            confirmButtonText="Continue Anyway"
            onCancel={this.cancelAction}
            onConfirm={this.confirmAction}
            {...this.props}
          />
          <Container className={classes.containerbg} component="main" >
            <BootstrapTooltip title="Logo">
              <h1 className={classes.logo} align="center">
                <Avatar alt="App Logo" src={this.props.tenantConfig.logoBigUrl} className={classes.logo} style={{maxWidth: '200px',maxHeight: '75px',width: 'auto', height: 'auto'}}/>
              </h1>
            </BootstrapTooltip>
            <h2 align="center" style={LOGIN_style.signTitle}>Sign In  </h2>
            <ValidatorForm className={classes.form} name="submitLoginForm" onSubmit={this.submitLoginForm} >
              <BootstrapTooltip title="Enter Username">
                <TextValidator
                  size="small"
                  variant="outlined"
                  validators={['required', 'isEmail']}
                  margin="normal"
                  fullWidth
                  id="emailid"
                  label="Username"
                  placeholder="Enter Username"
                  name="emailid"
                  autoComplete="email"
                  autoFocus
                  errorMessages={['*Required', 'Email is not valid.']}
                  value={this.state.fields.emailid} 
                  onChange={this.handleChange}
                /></BootstrapTooltip>
              <BootstrapTooltip title="Enter Password">
                <TextValidator
                  size="small"
                  variant="outlined"
                  margin="normal"
                  validators={['required']}
                  fullWidth
                  name="password"
                  label="Password"
                  placeholder="Enter Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  errorMessages={['*Required']}
                  value={this.state.fields.password} onChange={this.handleChange} /></BootstrapTooltip>

                
                <Grid className={classes.forgotpwd} item >
                  <BootstrapTooltip title="Forgot Password?">
                    <Link href="/ForgetPassword" variant="body2" className={classes.forgotFontSize} >
                      Forgot Password?
                </Link></BootstrapTooltip>
                </Grid>
                <Grid item xs className={classes.progressOutside}>
                  <Container className={classes.progressInside} maxWidth={false} style={{ paddingLeft: '10',paddingRight:'10',textAlign:'center' }}>
                    <BootstrapTooltip title="Login">
                      <div>
                        <Button type="submit" color="primary"  style={{marginTop:'20px', width:'100%'}} className={this.state.loading ? classes.disableBtn : classes.button} disabled={this.state.loading}>
                          Login
                {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </Button> 
                      
                        </div></BootstrapTooltip>
                  </Container>
                </Grid>
                
                
            {this.props.tenantConfig.redirectUrl? 
            <>
            <p  style={LOGIN_style.awsLineOption} > 
            <span style={LOGIN_style.awsOption}> OR </span></p>
            <Grid container >
              
              <Grid item style={{'margin':'auto'}} >
                <Button type="button" color="primary" style={{ marginTop:'20px', width:'100%'}} onClick={this.onSingleSingin} className={classes.button} disabled={this.state.loading}>
                Sign in with corporate ID
                {/* {     this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />} */}
                    </Button>
                </Grid>

             </Grid>
            </>
             :null}
            </ValidatorForm>
          </Container>
        </Container>
        <Footer />
      </user-login-container>
     :<div style={LOGIN_style.awsloader}><p>Please Wait....</p></div>  
    )
  }
}
export default withStyles(GlobalStyle)(Login);
